import { Component, OnInit } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { AdminMenuComponent } from '../admin-menu/admin-menu.component';
import { MasterAdminMenuComponent } from '../master-admin-menu/master-admin-menu.component';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/user.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserRoleEnum } from '../../enums/user-role-enum';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'site-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterModule,
    AdminMenuComponent,
    MasterAdminMenuComponent,
    CommonModule,
  ],
  templateUrl: './site-layout.component.html',
  styleUrl: './site-layout.component.css',
})
export class SiteLayoutComponent implements OnInit {
  userInfo = new User();
  role: any;
  roleEnum = UserRoleEnum;
  constructor(
    private router: Router,
    private authService: AuthService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.authService.observeLoggedUser().subscribe((user) => {
      if (user != null) {
        this.userInfo = new User();
        this.userInfo = user;
        this.role = user.role;
        /*if (
            this.userInfo.ProfilePictureFilename != undefined &&
            this.userInfo.ProfilePictureFilename != ""
         ) {
            this.userProfileImageUrl = "";
            this.userProfileImageUrl = this.userInfo.ProfilePictureFilename;
         }*/
      }
    });
  }

  logOut(userId: string): void {
    this.spinner.show();
    this.authService.userLogout(userId).subscribe(
      (response) => {
        this.spinner.hide();
        this.router.navigate(['/login']);
      },
      (error: any) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }
}
